import React, { useCallback, useState } from "react";

const rand = (min, max) => min + Math.random() * (max - min);
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export const BatSvg = () => (
  <svg viewBox="0 0 100 50" aria-hidden="true">
    <g className="hk-bat-wing-l">
      <path d="M44 24 C34 9, 18 4, 1 11 C10 15, 13 22, 8 29 C17 24, 23 27, 27 36 C31 29, 37 28, 44 33 Z" />
    </g>
    <g className="hk-bat-wing-r">
      <path d="M56 24 C66 9, 82 4, 99 11 C90 15, 87 22, 92 29 C83 24, 77 27, 73 36 C69 29, 63 28, 56 33 Z" />
    </g>
    <ellipse cx="50" cy="27" rx="5.5" ry="10" />
    <path d="M46.5 19 L44 10.5 L49.5 17 Z M53.5 19 L56 10.5 L50.5 17 Z" />
  </svg>
);

// depth: 0 = far (small, slow, faint), 1 = foreground (large, fast, crisp)
function makeFlight(initial) {
  const depth = Math.random();
  const size = Math.round(22 + depth * 62);
  const fromLeft = Math.random() < 0.5;
  const fromTop = Math.random() < 0.22;
  const yStart = rand(6, 82);
  const yDrift = rand(-32, 32);
  const yEnd = Math.min(92, Math.max(4, yStart + yDrift));
  const edgeL = `${-size - 40}px`;
  const edgeR = `calc(100vw + ${size + 40}px)`;
  return {
    "--size": `${size}px`,
    "--x0": fromTop ? `${rand(5, 90)}vw` : fromLeft ? edgeL : edgeR,
    "--x1": fromLeft ? edgeR : edgeL,
    "--y0": fromTop ? `${-size}px` : `${yStart}vh`,
    "--y1": `${yEnd}vh`,
    "--dur": `${rand(26, 40) - depth * 12}s`,
    "--delay": `${initial ? rand(0, 14) : rand(3, 16)}s`,
    "--bob": `${rand(2.2, 4.2)}s`,
    "--flap": `${pick([0.42, 0.5, 0.58, 0.66]) - depth * 0.12}s`,
    "--op": `${0.55 + depth * 0.4}`,
    "--blur": `${(1 - depth) * 1.4}px`,
    "--dir": fromLeft ? 1 : -1,
  };
}

export default function Bat() {
  const [flight, setFlight] = useState(() => makeFlight(true));
  const [key, setKey] = useState(0);

  const regenerate = useCallback((e) => {
    if (e.animationName !== "hk-bat-fly") return;
    setFlight(makeFlight(false));
    setKey((k) => k + 1);
  }, []);

  return (
    <div key={key} className="hk-bat" style={flight} onAnimationEnd={regenerate}>
      <div className="hk-bat-bob">
        <div className="hk-bat-body">
          <BatSvg />
        </div>
      </div>
    </div>
  );
}
